module.exports = __webpack_public_path__ + "static/media/jobs-call-sprite.ced5730b.svg";